import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveProductWithShopifyProductMutationVariables = Types.Exact<{
  input: Types.SaveProductWithShopifyProductInput;
}>;


export type SaveProductWithShopifyProductMutation = { __typename?: 'RootMutationType', saveProductWithShopifyProduct?: { __typename?: 'ProductMutationResult', product?: { __typename?: 'Product', id: string, title: string, sourceId?: string | null, sourceType?: string | null, onlineStoreUrl: string, featuredImage?: { __typename?: 'ProductImage', id: string, sourceId?: string | null, sourceType?: Types.ProductSourceType | null, src?: string | null } | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, originalPrice?: number | null, price?: number | null }> | null } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const SaveProductWithShopifyProductDocument = gql`
    mutation SaveProductWithShopifyProduct($input: SaveProductWithShopifyProductInput!) {
  saveProductWithShopifyProduct(input: $input) {
    product {
      id
      title
      sourceId
      sourceType
      onlineStoreUrl
      featuredImage {
        id
        sourceId
        sourceType
        src
      }
      variants {
        id
        originalPrice
        price
      }
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export type SaveProductWithShopifyProductMutationFn = Apollo.MutationFunction<SaveProductWithShopifyProductMutation, SaveProductWithShopifyProductMutationVariables>;

/**
 * __useSaveProductWithShopifyProductMutation__
 *
 * To run a mutation, you first call `useSaveProductWithShopifyProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProductWithShopifyProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProductWithShopifyProductMutation, { data, loading, error }] = useSaveProductWithShopifyProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProductWithShopifyProductMutation(baseOptions?: Apollo.MutationHookOptions<SaveProductWithShopifyProductMutation, SaveProductWithShopifyProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProductWithShopifyProductMutation, SaveProductWithShopifyProductMutationVariables>(SaveProductWithShopifyProductDocument, options);
      }
export type SaveProductWithShopifyProductMutationHookResult = ReturnType<typeof useSaveProductWithShopifyProductMutation>;
export type SaveProductWithShopifyProductMutationResult = Apollo.MutationResult<SaveProductWithShopifyProductMutation>;
export type SaveProductWithShopifyProductMutationOptions = Apollo.BaseMutationOptions<SaveProductWithShopifyProductMutation, SaveProductWithShopifyProductMutationVariables>;